import React from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';

function ToolPageContainer({ title, description, children, loading = false, disablePadding = false }) {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {/* Optional Header Section */}
      {(title || description) && (
        <Box sx={{ px: 3, pt: 3, pb: 1, flexShrink: 0 }}>
          {title && (
            <Typography component="h1" variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
      )}

      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1, overflow: 'hidden', p: disablePadding ? 0 : 3 }}>
        <Paper elevation={0} sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: disablePadding ? 0 : 2, position: 'relative', overflow: 'hidden' }}>
          {/* Loading Overlay */}
          {loading && (
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, bgcolor: 'rgba(255,255,255,0.7)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress />
            </Box>
          )}
          
          <Box sx={{ flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            {children}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default ToolPageContainer;
